import EmptyState from "@/components/empty-state";
import { Skeleton } from "@/components/ui/skeleton";
import { useApplicationList } from "@/hooks/application-list.hook";
import { cn } from "@/lib/utils";
import { Provider } from "jotai";
import { FC, HTMLAttributes } from "react";
import EditionSummary from "./edition-summary/edition-summary";

type ApplicationListProps = HTMLAttributes<HTMLDivElement>;

const ApplicationList: FC<ApplicationListProps> = (props) => {
  const { applications, isLoading, isError } = useApplicationList();

  if (isLoading) {
    return (
      <div className={cn("flex flex-col gap-4", props.className)}>
        {Array.from({ length: 2 }).map((_, index) => (
          <Skeleton
            key={index}
            className="h-8 bg-gray-200"
            style={{ height: "140px" }}
          />
        ))}
      </div>
    );
  }

  if (isError) {
    return (
      <EmptyState
        className={cn("mx-auto", props.className)}
        message="Ocurrió un error al cargar las postulaciones."
      />
    );
  }

  return applications.length ? (
    <div className={cn("flex flex-col gap-4", props.className)}>
      {applications.map((application) => (
        <Provider key={application.id}>
          <EditionSummary editionId={application.edition.id} />
        </Provider>
      ))}
    </div>
  ) : (
    <EmptyState
      className={cn("mx-auto", props.className)}
      message="No se encontró ninguna postulación pendiente o en curso."
    />
  );
};

export default ApplicationList;
